// extracted by mini-css-extract-plugin
module.exports = {"mainNavBar":"NavBar_mainNavBar__1ACAS","menu":"NavBar_menu__2D0Um","signOutErrorBar":"NavBar_signOutErrorBar__3HybS"};